// extracted by mini-css-extract-plugin
export default {"wrapper":"VideoPlayer_wrapper__a6ZRh","player":"VideoPlayer_player__kj7f0"};